@let notesInPanel = store.currentNotes | notesFilter: notesFilterMode.PANEL : !!store.ipcXML;
@let dmItemsLength = notesInPanel.length + store.currentComments.length;
@if (dmItemsLength) {
  <button
    mat-fab
    [class.is-not-visible]="store.inPrint || printPdf"
    title="items drawer"
    type="button"
    (click)="store.dmItemsDrawerOpen = true">
    @if (hasNoteWarnings()) {
      <mat-icon
        aria-hidden="false"
        class="inline-note-warning-sign"
        matBadgeColor="accent"
        matBadgeSize="small"
        svgIcon="notes-button-warning"
        [matBadge]="dmItemsLength"
        [matTooltip]="'notes.inline.warning.check' | translate" />
    } @else {
      <mat-icon
        aria-hidden="false"
        matBadgeColor="accent"
        matBadgeSize="small"
        svgIcon="notes"
        [matBadge]="dmItemsLength">
      </mat-icon>
    }
  </button>
}
